module.exports = __webpack_public_path__ + "img/equipamentos.ccbe8df2.jpg";